export const documentGridId = "ins-documents-grid";
export const MAX_DOCUMENT_DOWNLOAD_LIMIT = 200;
